import { useState, useEffect } from "react"

export default function PageClock(props) {
	const [nowTime, setNowTime] = useState("")
	const [nowDate, setNowDate] = useState({})
	const WEEKDAYS = ["日", "一", "二", "三", "四", "五", "六"]
	useEffect(() => {
		const intervalId = setInterval(() => {
			let now = new Date()
			let hour = ("0" + now.getHours()).slice(-2)
			let minute = ("0" + now.getMinutes()).slice(-2)
			let second = ("0" + now.getSeconds()).slice(-2)
			setNowTime(hour + ":" + minute + ":" + second)

			let year = now.getFullYear()
			let month = now.getMonth() + 1
			let date = now.getDate()
			let day = now.getDay()
			if (date != nowDate.date || month != nowDate.month || year != nowDate.year) {
				let r = year + "." + month + "." + date + " 星期" + WEEKDAYS[day]
				setNowDate({ year, month, date, day, r })
			}
		}, 1000)

		return () => clearInterval(intervalId)
	}, [])

	return(
	<div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", color: "#fff" }}>
		<div style={{ fontSize: "20px", fontWeight: "bold" }}>{nowTime}</div>
		<div style={{ fontSize: "14px", marginTop: "9px" }}>{nowDate.r}</div>
	</div>
	)
}
